import { render } from "./SalaryPendingTable.vue?vue&type=template&id=04406f3b"
import script from "./SalaryPendingTable.vue?vue&type=script&lang=js"
export * from "./SalaryPendingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__